module.exports = __webpack_public_path__ + "static/media/hadith_learning.987fd12d.png";